import { render } from "./index.vue?vue&type=template&id=62cc012a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=62cc012a&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=62cc012a&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cc012a"]])

export default __exports__